// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"dbfe890cc1cb0d61","6719":"aa876dd4f175ac3d"}[chunkId] + ".css";
};